<template>
        <div class='q-ma-xs' v-bind:class="{'q-ma-md': $q.screen.gt.sm}" >
        <q-scroll-observable @scroll = 'userHasScrolled'/>

        <div class="main_container q-pa-sm row q-subheading bg-blue-1 shadow-1 ellipsis" 
            v-bind:class="{'q-pa-sm' : $q.screen.gt.md, 'position-2' : isSecondPosition, 'shadow-3':isSecondPosition}" ref='main_container'>
             <q-slide-transition>
                <div v-if='!compactView'>
                    <div class="q-title items-center q-mt-md ellipsis" v-if='stanokInfo.length == 0'>В работе ничего нет</div>
                    <div v-if='stanokInfo.length != 0' class='row full-width'>
                        <div>
                            <div class='bg-secondary row q-mb-md text-white q-pa-xs q-caption items-baseline ellipsis' style="width:335px">
                                <i class="fas fa-info-circle q-mr-xs"/>по направлениям<i class="fas fa-angle-right q-ml-xs"/>
                            </div>
                            <div class=" q-mr-lg stanokField" >                
                                <div v-for='(item, key) in stanokInfo' :key = key class='row no-wrap q-mb-xs stanokField'  v-on:click='setStanokFilter(key)'>
                                    <div class="ellipsis underLine" style='width:250px'>
                                        {{ getStanokName(key) }}
                                    </div>
                                    <div class="ellipsis underLine " style='width:80px; text-align:right;'>
                                        {{item}} <span class='text-light q-caption'>кв.м.</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div>
                            <div class='bg-secondary row q-mb-md text-white q-pa-xs q-caption items-baseline ellipsis' style="width:335px">
                                <i class="fas fa-info-circle q-mr-xs "/>по материалам<i class="fas fa-angle-right q-ml-xs" />
                            </div>
                            <div class="">
                                <div v-for='(item, key) in materialInfo' :key = key  class='row q-mb-xs no-wrap  stanokField' v-on:click='setMaterialFilter(key)'>
                                    <div class="ellipsis underLine" style='width:250px'>
                                        {{ getMaterialName(key) }}
                                    </div>
                                    <div class="ellipsis underLine" style='width:80px; text-align:right;'>
                                        {{item}}  <span class='text-light q-caption'>кв.м.</span>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
             </q-slide-transition>
            <div class='row no-wrap justify-end full-width' v-if='$q.screen.gt.xs'>
                <q-btn dense flat="" color='primary' @click='compactView = !compactView'>
                    <div class='q-caption text-faded text-primary' v-if='!compactView'>Скрыть информер</div>
                    <div class='q-caption text-faded text-primary' v-if='compactView'>Показать информер</div>
                </q-btn>
            </div>
        </div>

    </div>

</template>


<script>
/* eslint-disable */
export default {

    name : 'printInfo',

    data() {
        return {
            compactView : true,
            isSecondPosition : false,
        }
    },

    created() {
        this.$store.dispatch('getInWorkInfo');
    },

    computed : {
        stanokInfo() {
            return this.$store.getters.getStanokInfo;
        },
        materialInfo() {
            return this.$store.getters.getMaterialInfo;
        },
    },

    methods :{

        userHasScrolled(scroll) {
            if (this.$q.screen.gt.sm) {
                let el = this.$refs.main_container.clientHeight;
                if (scroll.position >= el) {
                    this.isSecondPosition = true;
                //    this.compactView = true;
                } else {
                    this.isSecondPosition = false;
                    // this.compactView = false;
                }
            } else {
                this.isSecondPosition = false;
                this.compactView = false;
            }

            
        },
        
        setStanokFilter(stanok) {
            eventBus.$emit('setStanokFilter', stanok);
        },
        setMaterialFilter(material) {
            eventBus.$emit('setMaterialFilter', material);
        },
        getInfo() {
            this.$store.dispatch('getInWorkInfo');
        },
        
        getStanokName(id) {            
            let q = this.$store.getters.getDirectionById(id);
            if (q == null) return '';
            return  q.name;
        },
        
        getMaterialName(id) {
            let q = this.$store.getters.getMaterialById(id);
            if (q == null) return '';
            return  q.name;
        },
    }

}
</script>
<style lang="scss" scoped>
    .position-2 {
        position : fixed;
        top : 58px;
        left : calc(1.5%);

        z-index: 2;
        width:97%;
    }
    .stanokField {
        padding : 2px;
        padding-left: 5px;
        cursor: pointer;
        border-radius: 2px;
        &:hover {
            background: rgb(186, 227, 255);
        }
    }
    .main_container {
        border : 1px solid rgb(214, 214, 214);
        border-radius: 2px;
    }
    .underLine {
        border-bottom : 1px solid rgb(218, 218, 218);
    }
</style>

